import axios from 'axios';

const getAccountsListApi = async (token, edit, id) => {
  try {
    let url;
    if (edit) url = `/accounting/list/selectParent_toUpdate/${id}`;
    else url = `/accounting/list/selectParent_toCreate`;

    const res = await axios({
      method: 'get',
      baseURL: process.env.REACT_APP_BASE_TEST_URL,
      // baseURL: 'https://testclient-api.fatoorah.sa/apiAdmin',
      url: url,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'applications/json',
        Authorization: 'Bearer ' + token,
        lang: 'ar'
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default getAccountsListApi;
